import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { clearSelectionsAtom } from '~/atoms/no-code-atoms';
import type { VmStatus } from './vm/useVm';

export default function useHandleVmStatus({ testContentId }: { testContentId: string }) {
  const clearSelections = useSetAtom(clearSelectionsAtom);

  const alertAction = useCallback(
    (vmStatus: VmStatus) => {
      if (vmStatus?.state === 'error') {
        console.error('VM error:', vmStatus.humanDetails);

        clearSelections();
        // TODO: re-enable this
        // modals.open({
        //   title: <span className="font-bold">Preview Failed</span>,
        //   children: <QualityCheckAlertDialog testId={testId} />,
        //   color: 'red',
        // });
      }
    },
    [testContentId],
  );

  return alertAction;
}
